// GENERATED FILE - DO NOT MODIFY

export enum MessageEntityTypeDto {
    Booking = "Booking",
    Company = "Company",
    FoodOrder = "FoodOrder",
    ServiceRequest = "ServiceRequest",
    Invoice = "Invoice",
    CheckIn = "CheckIn",
}